export default __webpack_public_path__ + "static/media/wish.697829dc.jpg";